module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/978a7854350d260c1d463f8d679ebea5.png";